var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 7.5H12.5V3.33333C12.5 2.875 12.125 2.5 11.6667 2.5H8.33334C7.87501 2.5 7.50001 2.875 7.50001 3.33333V7.5H6.175C5.43334 7.5 5.05834 8.4 5.58334 8.925L9.40834 12.75C9.73334 13.075 10.2583 13.075 10.5833 12.75L14.4083 8.925C14.9333 8.4 14.5667 7.5 13.825 7.5ZM4.16667 15.8333C4.16667 16.2917 4.54167 16.6667 5.00001 16.6667H15C15.4583 16.6667 15.8333 16.2917 15.8333 15.8333C15.8333 15.375 15.4583 15 15 15H5.00001C4.54167 15 4.16667 15.375 4.16667 15.8333Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon _download_.d8b6c132c5298998bd3780f650e57f11.svg";
export { ForwardRef as ReactComponent };